export enum ContactClaimType {
  MOBILE_PHONE_NUMBER = 'MOBILE_PHONE_NUMBER',
  EMAIL = 'EMAIL',
  SSIN = 'SSIN',
  NAMES = 'NAMES',
}
